"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthGate = void 0;
const react_1 = require("next-auth/react");
const react_2 = __importStar(require("react"));
const DefaultLoadingFallback_1 = require("./DefaultLoadingFallback");
const constants_1 = require("../../../constants");
const LoginRedirect = () => {
    (0, react_2.useEffect)(() => {
        if (typeof window === 'undefined') {
            return;
        }
        const params = new URLSearchParams();
        params.set('destination', `${window.location.pathname}${window.location.search}`);
        const redirectTo = `${constants_1.IDENTITY_BASE_PATH}/login?${params.toString()}`;
        window.location.assign(redirectTo);
    }, []);
    return null;
};
const AuthGate = ({ children, loadingFallback = react_2.default.createElement(DefaultLoadingFallback_1.DefaultLoadingFallback, null), unauthenticatedFallback = react_2.default.createElement(LoginRedirect, null), isPublic = false, }) => {
    const session = (0, react_1.useSession)();
    if (isPublic) {
        return react_2.default.createElement(react_2.default.Fragment, null, children);
    }
    if (session.status === 'loading') {
        return react_2.default.createElement(react_2.default.Fragment, null, loadingFallback);
    }
    if (session.status === 'unauthenticated') {
        return react_2.default.createElement(react_2.default.Fragment, null, unauthenticatedFallback);
    }
    return react_2.default.createElement(react_2.default.Fragment, null, children);
};
exports.AuthGate = AuthGate;
